<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                    
                <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                    <h1 class="h3 mb-0 text-gray-800">Dashboard</h1>
                </div>

                <div class="card shadow adaptative-container">
                    <div class="container-fluid">
                        <app-bi-dashboard></app-bi-dashboard>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>